import React from 'react';
import { withTranslation } from 'react-i18next';
import { createReservation } from '../../../models/reservation';
import { getAttendants } from '../../../models/attendant';
import { Alert } from 'reactstrap';

import Button from '../../../components/button';
import ReactSVG from 'react-svg';
import iconExcludedAttendant from "../../../assets/images/icon-excluded-attendant.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class KioskExcludedAttendant extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      attendants: null,
      excludedAttendants: {},
      addExcludedAttendantError: null,
      error: null
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.retrieveAttendants();
    if(this.props.reservation){
      let existingExcludedAttendants = this.props.reservation.user.excludedAttendants;
      let excludedAttendants = {};
      if(existingExcludedAttendants.length){
        existingExcludedAttendants.forEach(exc => {
          excludedAttendants[exc.attendantId] = true;
        })
      }
      this.setState({excludedAttendants});
    }
  }

  retrieveAttendants() {
    getAttendants().then(
      (result) => {
        this.setState({
          attendants: result     
        });
      },
      (error) => {
        this.setState({ error });
      }
    );
  }

  handleChange(event, att, clear) {
    event.stopPropagation();
    let excludedAttendants = this.state.excludedAttendants;
    let attendantId = att.id;
      if(!clear){
        if(Object.keys(excludedAttendants).length<4 && (Object.keys(excludedAttendants).length<(this.state.attendants.length-1))){
          excludedAttendants[attendantId] = attendantId;
          this.setState({addExcludedAttendantError: null});
        } else {
          this.setState({addExcludedAttendantError: "Please remove an excluded attendant to add a new one."})
        }
      } else {
        if(attendantId in excludedAttendants) delete excludedAttendants[attendantId];
        this.setState({addExcludedAttendantError: null});
      }
      this.setState({excludedAttendants});
  }

  handleSubmit(e) {
    e.preventDefault();
    let res = this.props.reservation;
    res.replacingReservationId = res.reservationId;
    res.excludedAttendantIDs = Object.keys(this.state.excludedAttendants);
    createReservation(res)
      .then(res => {
        this.props.handleUpdateReservation(res);
        this.props.handleScreenChange("pay");
      }, error => {
        this.setState({
          error,
          isSubmitting: false,
        })
      });
  }

  render() {
    const { t, reservation, excludeButton } = this.props;
    const { error, addExcludedAttendantError, attendants, excludedAttendants } = this.state;
      return attendants?
        excludeButton?
          (attendants.length?
            <div className="position-relative">
              <Button className="d-block mt-4 mb-4 mx-auto" size="lg" type="secondary" onClick={() => this.props.handleScreenChange('excludedAttendant')}>{t('Exclude Attendants')}</Button>
              {Object.keys(excludedAttendants).length?
                <div className="excludedAmount">{Object.keys(excludedAttendants).length}</div>
              :null}
            </div>
          :null)
        :
          <div className="col-12">
          <h2 className="mb-3">{t("Exclude Attendants")}</h2>
          <form autoComplete="off" onSubmit={this.handleSubmit} >
            {error?<Alert className="mb-4" color="danger">{t(error)}</Alert>:null}
            {addExcludedAttendantError?<Alert className="mb-4" color="warning">{t(addExcludedAttendantError)}</Alert>:null}
            <div className="form-group">
              <div className="row">
                {attendants && attendants.map((att, i) => {
                  return <div className='col-4' key={i} onClick={(e) => this.handleChange(e,att)}>
                    <div className="excluded-attendant">
                      {att.id in excludedAttendants?
                        <div className="excludedIcon"><ReactSVG className="icon-excluded" src={iconExcludedAttendant} alt="Excluded Attendant Icon" /></div>
                      :null}
                      <div>{att.name}</div>
                      {att.id in excludedAttendants?
                        <div className="deleteMerchAmount" onClick={(e) => this.handleChange(e,att,true)}><FontAwesomeIcon name="Remove Excluded Attendant" className="" icon={['far', 'trash-alt']} /></div>
                      :null}
                    </div>
                  </div>
                })}
              </div>
            </div>
            <div>
              <Button className="btn-primary btn-lg mb-3" large>{t("Submit")}</Button>
            </div>
            <div>
              <Button type="outline-primary" onClick={() => this.props.handleScreenChange(reservation.advanceReservation?'confirm':'pay')}>{t('Cancel')}</Button>
            </div>
          </form>
        </div>
      :null
  }
}

export default withTranslation()(KioskExcludedAttendant);